import { Action } from '../../types';
import { Cycle } from '@wix/ambassador-premium-store/types';

const CHECKOUT_ACTIONS_PREFIX = 'CHECKOUT/';

function generateCheckoutActionName(actionsName: string) {
  return `${CHECKOUT_ACTIONS_PREFIX}${actionsName}`;
}

function createAction<T>(type: string) {
  return (value?: T): Action => {
    return {
      type,
      payload: value,
    };
  };
}

export const CheckoutActionNames = {
  SET_ORDER_PAGE_EVENT_AGGREGATOR: generateCheckoutActionName(
    'SET_ORDER_PAGE_EVENT_AGGREGATOR',
  ),
  SET_ALTERNATIVE_CYCLE: generateCheckoutActionName('SET_ALTERNATIVE_CYCLE'),
  SET_SHOW_CUSTOM_FOOTER: generateCheckoutActionName('SET_SHOW_CUSTOM_FOOTER'),
};

export const CheckoutActions = {
  setOrderPageEventAggregator: createAction<string>(
    CheckoutActionNames.SET_ORDER_PAGE_EVENT_AGGREGATOR,
  ),
  setAlternativeCycle: createAction<Cycle | undefined>(
    CheckoutActionNames.SET_ALTERNATIVE_CYCLE,
  ),
  setShowCustomFooter: createAction<boolean>(
    CheckoutActionNames.SET_SHOW_CUSTOM_FOOTER,
  ),
};
